import React from 'react';

const MyData: React.FC = () => {
  return (
    <div className="my-data">
      <h1>Meine Daten</h1>
      <p>Hier können Sie Ihre persönlichen Informationen verwalten.</p>
    </div>
  );
};

export default MyData;
